import styled from 'styled-components'

export const SearchBarWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
`

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  color: ${(props) => props.theme.colors.font.grey2};
`

export const StyledSearchInput = styled.input`
  width: 100%;
  height: 2.5rem;
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.box.borderRadius};
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.font.primary};
  padding: ${(props) => props.theme.spacing.small};
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  box-sizing: border-box;
  font-size: 0.875rem;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.accentColor};
    box-shadow: 0 0 0 2px rgba(103, 217, 212, 0.15);
  }

  &::placeholder {
    color: ${(props) => props.theme.colors.font.grey2};
  }
`

export const ClearButton = styled.button`
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: ${(props) => props.theme.colors.font.grey2};
  font-size: 1rem;
  line-height: 1;

  &:hover {
    color: ${(props) => props.theme.colors.font.primary};
  }
`

export const ShortcutHint = styled.span`
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.75rem;
  color: ${(props) => props.theme.colors.font.grey2};
  background-color: ${(props) => props.theme.colors.secondary};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 4px;
  padding: 0.1rem 0.35rem;
  pointer-events: none;
  white-space: nowrap;
`
